import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Accounts from "./ScreenAccounts/Accounts/Accounts";
import {
  OPPORTUNITY_HANDBOOK, OPPORTUNITY_KANBAN, OPPORTUNITY_REALIZATION, OPPORTUNITY_TICKETS,
  ROLE_ADMINISTRATOR,
  ROLE_CLIENT,
  ROLE_DIRECTOR,
  ROLE_EMPLOYEE,
} from "../config/constants";
import {
  useProfile,
  isProfileRoleTypeTags, isProfileOpportunityTypeTags,
} from "@vokymlak/kabinet-ui";
import {Nomenclature} from "./ScreenNomenclatures/NomenclaturePage";
import {Nomenclatures} from "./ScreenNomenclatures/Nomenclatures";
import {NomenclaturesRouting} from "./ScreenNomenclatures/NomenclaturesRouting";
import {Cows} from "./ScreenCows/Cows";
import {ProductionOrders} from "./ScreenErp/ScreenProductionOrders/ProductionOrders";
import {BoningOrders} from "./ScreenErp/ScreenBoningOrders/BoningOrders";
import {SiteShopOrders} from "./ScreenSite/SiteShopOrders";
import {Contractors} from "./ScreenCrm/Contractors";
import {Branches} from "./ScreenCrm/Branches";
import {IncomeOrders} from "./ScreenCrm/ScreenIncomeOrders/IncomeOrders";
import {RealizationOrder} from "./ScreenCrm/ScreenRealizationOrders/RealizationOrder";
import {RealizationOrders} from "./ScreenCrm/ScreenRealizationOrders/RealizationOrders";
import {IncomeOrder} from "./ScreenCrm/ScreenIncomeOrders/IncomeOrder";
import {ProductionOrder} from "./ScreenErp/ScreenProductionOrders/ProductionOrder";
import {BoningOrder} from "./ScreenErp/ScreenBoningOrders/BoningOrder";
import PlanWarehouse from "./ScreenPlans/PlanWarehouseNew/PlanWarehouse";
import {Printers} from "./ScreenPrinters/Printers";
import {PrinterFiles} from "./ScreenPrinters/PrinterFiles";
import {IntegrationAlfabank} from "./ScreenIntegrations/IntegrationAlfabank";
import {Employees} from "./ScreenAccounts/Employees";
import {HandbookRouting} from "./modules/ScreenHandbook/HandbookRouting";
import {TicketsRouting} from "./modules/ScreenTickets/TicketsRouting";
import {KanbanRouting} from "./modules/ScreenKanban/KanbanRouting";
import {CowsRouting} from "./ScreenCows/CowsRouting";

export const Routing = () => {
  const { profile } = useProfile();

  return (
    !!profile && (
    <Routes>
      {isProfileRoleTypeTags(profile, [ROLE_CLIENT]) && (
        <>
        </>
      )}

      {(isProfileRoleTypeTags(profile, [
        ROLE_ADMINISTRATOR,
        ROLE_DIRECTOR,
      ]) || isProfileOpportunityTypeTags(profile, [
        OPPORTUNITY_REALIZATION,
      ])) && (
        <>
          <Route path="/realization-orders" element={<RealizationOrders />} />
          <Route path="/realization/:realizationOrderUuid" element={<RealizationOrder />} />
        </>
      )}

      {isProfileRoleTypeTags(profile, [
        ROLE_ADMINISTRATOR,
        ROLE_DIRECTOR,
        ROLE_EMPLOYEE,
      ]) && (
        <>
          <Route path="/employees" element={<Employees/>}/>
          {/*<Route path="/clients" element={<Clients/>}/>*/}

          <Route path="/all-nomenclatures" element={<Nomenclatures isEdit={true} />} />
          <Route path="/nomenclatures/*" element={<NomenclaturesRouting />} />
          <Route path="/nomenclature/:nomenclatureUuid/*" element={<Nomenclature />} />

          <Route path="/cows/*" element={<CowsRouting />} />

          <Route path="/site-shop-orders" element={<SiteShopOrders />}/>

          <Route path="/contractors" element={<Contractors />} />

          <Route path="/plan-warehouse" element={<PlanWarehouse/>}/>

          <Route path="/income-orders" element={<IncomeOrders />} />
          <Route path="/income/:incomeOrderUuid" element={<IncomeOrder />} />

          <Route path="/production-orders" element={<ProductionOrders />} />
          <Route path="/production/:productionOrderUuid" element={<ProductionOrder />} />

          <Route path="/boning-orders" element={<BoningOrders />} />
          <Route path="/boning/:boningOrderUuid" element={<BoningOrder />} />

          <Route path="/printers" element={<Printers />} />
          <Route path="/printer-files" element={<PrinterFiles />} />
        </>
      )}

      {isProfileRoleTypeTags(profile, [
        ROLE_ADMINISTRATOR,
        ROLE_DIRECTOR,
      ]) && (
        <>
          <Route path="/branches" element={<Branches />} />

          <Route path="/integration-alfabank" element={<IntegrationAlfabank />} />

          {isProfileRoleTypeTags(profile, [ROLE_ADMINISTRATOR]) && (
            <>
              <Route path="/accounts" element={<Accounts />} />
            </>
          )}
        </>
      )}

      {(isProfileRoleTypeTags(profile, [
        ROLE_ADMINISTRATOR,
        ROLE_DIRECTOR,
      ]) || isProfileOpportunityTypeTags(profile, [
        OPPORTUNITY_KANBAN,
      ])) && (
        <>
          <Route path="/kanban/*" element={<KanbanRouting/>}/>
        </>
      )}

      {(isProfileRoleTypeTags(profile, [
        ROLE_ADMINISTRATOR,
        ROLE_DIRECTOR,
        ROLE_EMPLOYEE,
      ]) || isProfileOpportunityTypeTags(profile, [
        OPPORTUNITY_HANDBOOK,
      ])) && (
        <>
          <Route path="/handbook/*" element={<HandbookRouting/>}/>
        </>
      )}

      {(isProfileRoleTypeTags(profile, [
        ROLE_ADMINISTRATOR,
        ROLE_DIRECTOR,
      ]) || isProfileOpportunityTypeTags(profile, [
        OPPORTUNITY_TICKETS,
      ])) && (
        <>
          <Route path="/tickets/*" element={<TicketsRouting/>}/>
        </>
      )}


      {isProfileRoleTypeTags(profile, [ROLE_CLIENT]) && (
        <Route
          exact
          path="/"
          element={<Navigate to="/my" replace />}
        />
      )}

      {isProfileRoleTypeTags(profile, [
        ROLE_DIRECTOR,
        ROLE_EMPLOYEE,
      ]) && (
        <Route
          exact
          path="/"
          element={<Navigate to="/all-nomenclatures" replace />}
        />
      )}

      {isProfileRoleTypeTags(profile, [ROLE_ADMINISTRATOR]) && (
        <Route
          exact
          path="/"
          element={<Navigate to="/accounts" replace />}
        />
      )}

      <Route path="/login" element={<Navigate to="/" />} />
    </Routes>
  )
  );
};
